import Typography from "@mui/material/Typography";
import { ReactNode } from "react";

const TicketItemHeader = ({ children }: { children: ReactNode }) => {
  return (
    <Typography sx={{ fontSize: "10px", color: "#202124", opacity: 0.5 }}>
      {children}
    </Typography>
  );
};

export default TicketItemHeader;
